"use client";

import { useSyncExternalStore } from "react";

const subscribe = () => () => {};
const get_client = () => true;
const get_server = () => false;

// false on the server and during hydration, true right after (one extra render, no setState in an effect).
// Replaces chawk-bazar/ciseco `useIsHydrated`, jument `useHydrated` and jument's inline copies (SellerRequest, Account auth guard).
// A component first mounted after hydration (client navigation) gets true at once.
export default function useIsHydrated() {
	return useSyncExternalStore(subscribe, get_client, get_server);
}
